import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';
import { CommunityRank } from './types';

const borderColorMap: Record<CommunityRank, string> = {
  'COMMUNITY LEADER': token('color.background.accent.purple.subtle'),
  "I'M NEW HERE": token('color.background.accent.lime.subtle'),
  'RISING STAR': token('color.background.accent.teal.subtle'),
  'MARKETPLACE PARTNER': token('color.background.accent.orange.subtle'),
  'SOLUTION PARTNER': token('color.background.accent.green.subtle'),
  'COMMUNITY MANAGER': token('color.background.accent.yellow.subtle'),
  'ATLASSIAN TEAM': token('color.background.accent.blue.subtle'),
  BANNED: token('color.background.accent.gray.bolder'),
  VISITOR: token('color.background.accent.blue.subtle'),
};
const defaultBorderColor = token('color.background.accent.blue.subtle');

const getBorderColor = (rank: CommunityRank) => ({
  borderColor: borderColorMap[rank] || defaultBorderColor,
});

export const RankLozenge = ({
  rank,
  nicknameLength,
}: {
  rank: CommunityRank;
  nicknameLength: number;
}) => {
  return (
    <span
      role="status"
      aria-label={`Community rank: ${rank}`}
      css={[
        badgeStyles,
        nicknameLength > 32 && wrappedLozengeDesktopStyles,
        nicknameLength > 18 && wrappedLozengeTabletStyles,
      ]}
      style={getBorderColor(rank)}
    >
      {rank}
    </span>
  );
};

const badgeStyles = css({
  padding: `${token('space.100')} ${token('space.200')}`,
  border: `2px solid`,
  borderRadius: '56px',
  fontSize: token('space.150'),
  fontFamily: token('font.family.brand.body'),
  fontWeight: token('font.weight.semibold'),
  color: token('color.text'),
  textTransform: 'uppercase',
  lineHeight: '16px',
  height: '35px',
  marginTop: '5px',
  '@media (max-width: 768px)': {
    order: 5,
  },
  '@media (min-width: 768px)': {
    order: -1,
  },
});

// 32 chars, on the 33rd lozenge appears above name. Reduce gap to 8px on wrapped lozenge.
const wrappedLozengeDesktopStyles = css({
  '@media (min-width: 1280px)': {
    marginTop: '0px',
    marginBottom: '-8px',
  },
});

// 18 chars, on the 19th lozenge appears above name. Reduce gap to 8px on wrapped lozenge.
const wrappedLozengeTabletStyles = css({
  '@media (min-width: 768px) and (max-width: 1279px)': {
    marginTop: '0px',
    marginBottom: '-8px',
  },
});
